module.exports = __webpack_public_path__ + "img/筑想科技.3dfec26e.png";